module.exports = __webpack_public_path__ + "assets/658ebe6332f7fa8fdf664e01b91befd8.svg";